import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/authTenantSlice";

import authTenantApis from "src/api/authTenant";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// login request saga
const LoginRequestSaga = function* LoginRequestSaga({
  payload,
}: ReturnType<typeof actions.loginRequest> & {
  payload: { email: string; password: string };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.login,
      payload
    );

    yield put(actions.loginRequestSuccess(response as any));
  } catch (error) {
    yield put(
      actions.loginRequestError({
        message:
          error instanceof Error
            ? error?.message
            : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG,
        code: (error as any)?.code,
      })
    );
  }
};

// self-serve sign-up wizard sagas
const SendSignupOtpRequestSaga = function* SendSignupOtpRequestSaga({
  payload,
}: ReturnType<typeof actions.sendSignupOtpRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.sendSignupOtp,
      payload
    );
    yield put(actions.sendSignupOtpSuccess(response as any));
  } catch (error) {
    yield put(
      actions.sendSignupOtpError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const VerifySignupOtpRequestSaga = function* VerifySignupOtpRequestSaga({
  payload,
}: ReturnType<typeof actions.verifySignupOtpRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.verifySignupOtp,
      payload
    );
    yield put(actions.verifySignupOtpSuccess(response as any));
  } catch (error) {
    yield put(
      actions.verifySignupOtpError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const CompleteSignupRequestSaga = function* CompleteSignupRequestSaga({
  payload,
}: ReturnType<typeof actions.completeSignupRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.completeSignup,
      payload
    );
    yield put(actions.completeSignupSuccess(response as any));
  } catch (error) {
    yield put(
      actions.completeSignupError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// profile email verification sagas (covers admin-created tenants)
const SendEmailOtpRequestSaga = function* SendEmailOtpRequestSaga() {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.sendEmailOtp
    );
    yield put(actions.sendEmailOtpSuccess(response as any));
  } catch (error) {
    yield put(
      actions.sendEmailOtpError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const VerifyEmailOtpRequestSaga = function* VerifyEmailOtpRequestSaga({
  payload,
}: ReturnType<typeof actions.verifyEmailOtpRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.verifyEmailOtp,
      payload
    );
    yield put(actions.verifyEmailOtpSuccess(response as any));
  } catch (error) {
    yield put(
      actions.verifyEmailOtpError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// forgot password saga
const ForgotPasswordRequestSaga = function* ForgotPasswordRequestSaga({
  payload,
}: ReturnType<typeof actions.forgotPasswordRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.forgotPassword,
      payload
    );
    yield put(actions.forgotPasswordSuccess(response as any));
  } catch (error) {
    yield put(
      actions.forgotPasswordError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// reset password saga
const ResetPasswordRequestSaga = function* ResetPasswordRequestSaga({
  payload,
}: ReturnType<typeof actions.resetPasswordRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.resetPassword,
      payload
    );
    yield put(actions.resetPasswordSuccess(response as any));
  } catch (error) {
    yield put(
      actions.resetPasswordError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get user details saga
const GetUserDetailsRequestSaga =
  function* GetUserDetailsRequestSaga({}: ReturnType<
    typeof actions.getUserDetailsRequest
  >) {
    try {
      const response: common.ResponseGenerator = yield call(
        authTenantApis.getUserDetails
      );

      console.log("response", response);

      yield put(
        actions.getUserDetailsSuccess({ data: (response as any)?.user } as any)
      );
    } catch (error) {
      yield put(
        actions.getUserDetailsError(
          error instanceof Error
            ? error?.message
            : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
        )
      );
    }
  };

// edit user request saga
const EditUserRequestSaga = function* EditUserRequestSaga({
  payload,
}: ReturnType<typeof actions.editUserRequest> & {
  payload: {
    firstName: string;
    lastName?: string;
    email: string;
    password?: string;
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      authTenantApis.updateProfile,
      payload
    );

    yield put(actions.editUserSuccess(response as any));
  } catch (error) {
    yield put(
      actions.editUserError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// edit company details request saga
const EditCompanyDetailsRequestSaga =
  function* EditCompanyDetailsRequestSaga({
    payload,
  }: ReturnType<typeof actions.editCompanyDetailsRequest> & {
    payload: {
      gst?: string;
      addressLine1?: string;
      addressLine2?: string;
      city?: string;
      state?: string;
      pincode?: string;
    };
  }) {
    try {
      const response: common.ResponseGenerator = yield call(
        authTenantApis.updateCompanyDetails,
        payload
      );

      yield put(actions.editCompanyDetailsSuccess(response as any));
    } catch (error) {
      yield put(
        actions.editCompanyDetailsError(
          error instanceof Error
            ? error?.message
            : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
        )
      );
    }
  };

export default function* authTenantSaga() {
  yield all([takeEvery(actions.loginRequest, LoginRequestSaga)]);
  yield all([
    takeEvery(actions.getUserDetailsRequest, GetUserDetailsRequestSaga),
  ]);
  yield all([takeEvery(actions.editUserRequest, EditUserRequestSaga)]);
  yield all([
    takeEvery(
      actions.editCompanyDetailsRequest,
      EditCompanyDetailsRequestSaga
    ),
  ]);
  yield all([
    takeEvery(actions.sendSignupOtpRequest, SendSignupOtpRequestSaga),
  ]);
  yield all([
    takeEvery(actions.verifySignupOtpRequest, VerifySignupOtpRequestSaga),
  ]);
  yield all([
    takeEvery(actions.completeSignupRequest, CompleteSignupRequestSaga),
  ]);
  yield all([takeEvery(actions.sendEmailOtpRequest, SendEmailOtpRequestSaga)]);
  yield all([
    takeEvery(actions.verifyEmailOtpRequest, VerifyEmailOtpRequestSaga),
  ]);
  yield all([
    takeEvery(actions.forgotPasswordRequest, ForgotPasswordRequestSaga),
  ]);
  yield all([
    takeEvery(actions.resetPasswordRequest, ResetPasswordRequestSaga),
  ]);
}
